import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../RTEEditable.interfaces';

export const ListItemElement: FC<IRTERenderElementProps> = (props) => {
  const { element, children } = props;
  const attributes = props.attributes ?? {};

  return (
    <li
      {...element.attr}
      {...attributes}
      style={{
        listStylePosition: 'outside',
      }}
    >
      {children}
    </li>
  );
};
